'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _normalizr = require('normalizr');

var _requirementSchema = require('./requirementSchema');

var _requirementSchema2 = _interopRequireDefault(_requirementSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requirementSetSchema = new _normalizr.Schema('requirementSets', { idAttribute: 'code' });

requirementSetSchema.define({
    requirements: (0, _normalizr.arrayOf)(_requirementSchema2.default)
});

exports.default = requirementSetSchema;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/api/schemas/requirementSetSchema.js
// module id = 1292
// module chunks = 0